/**
 * Transforma o erro de validacao da API em texto que diz O QUE esta errado.
 *
 * O backend responde 400 com `message: "Dados invalidos"` — sempre esse texto,
 * pra QUALQUER recusa — e poe o motivo real em `details`. Tela que mostra so a
 * `message` deixa o operador sem saber qual campo recusou: foi o que aconteceu
 * em 11/08/2026, editando o e-mail de um servidor, e custou uma investigacao
 * inteira pra descobrir que o motivo estava no payload da resposta o tempo
 * todo.
 *
 * `details` chega em dois formatos:
 *  - zod (falha de schema): { fieldErrors: { campo: [msg] }, formErrors: [msg] }
 *  - Errors.validation (regra de negocio): { campo: "motivo" }
 */
export function mensagemDeErro(err: unknown, fallback = "Erro ao salvar"): string {
  const e = err as { message?: string; details?: Record<string, unknown> } | undefined;
  const det = e?.details as
    | { fieldErrors?: Record<string, string[]>; formErrors?: string[] }
    | Record<string, unknown>
    | undefined;
  const partes: string[] = [];

  if (det) {
    const zod = det as { fieldErrors?: Record<string, string[]>; formErrors?: string[] };
    if (zod.fieldErrors) {
      for (const [campo, msgs] of Object.entries(zod.fieldErrors)) {
        if (msgs?.length) partes.push(`${campo}: ${msgs.join(", ")}`);
      }
    } else {
      // Regra de negocio: { campo: "motivo" } direto na raiz.
      for (const [campo, v] of Object.entries(det)) {
        if (typeof v === "string") partes.push(`${campo}: ${v}`);
      }
    }
    if (zod.formErrors?.length) partes.push(...zod.formErrors);
  }

  const base = e?.message || fallback;
  // Sem detalhe nenhum, "Dados invalidos" sozinho nao ajuda ninguem — troca
  // pelo fallback, que ao menos diz qual acao falhou.
  if (partes.length === 0) return base === "Dados invalidos" ? fallback : base;
  return `${base} — ${partes.join(" | ")}`;
}
